import { render, staticRenderFns } from "./TbsCalculatorDataTable.vue?vue&type=template&id=14b55d11&scoped=true&"
import script from "./TbsCalculatorDataTable.vue?vue&type=script&lang=js&"
export * from "./TbsCalculatorDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TbsCalculatorDataTable.vue?vue&type=style&index=0&id=14b55d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b55d11",
  null
  
)

export default component.exports